module.exports = __webpack_public_path__ + "media/expo/conference@3x-ee246a68.png";